import { Toaster } from "@/components/ui/toaster";
import { Toaster as Sonner } from "@/components/ui/sonner";
import { TooltipProvider } from "@/components/ui/tooltip";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

// Swedish pages
import Index from "./pages/Index";
import AIConsulting from "./pages/AIConsulting";
import ThreeDPrinting from "./pages/3DPrinting";
import MusicProduction from "./pages/MusicProduction";
import AIMusicDreams from "./pages/AIMusicDreams";
import ArtistsPage from "./pages/ArtistsPage";
import Contact from "./pages/Contact";
import CustomersPage from "./pages/CustomersPage";
import AutomationsPage from "./pages/AutomationsPage";
import KlagobotPage from "./pages/KlagobotPage";
import SwishkassaPage from "./pages/SwishkassaPage";

// English pages — fully translated
import EnPage from "./pages/en/EnPage";
import EnKlagobotPage from "./pages/en/EnKlagobotPage";
import EnSwishkassaPage from "./pages/en/EnSwishkassaPage";

// English pages — route wrappers (Swedish content, pending full translation)
import EnAIConsultingPage from "./pages/en/EnAIConsultingPage";
import EnAutomationsPage from "./pages/en/EnAutomationsPage";
import EnCustomersPage from "./pages/en/EnCustomersPage";
import EnContactPage from "./pages/en/EnContactPage";
import En3DPrintingPage from "./pages/en/En3DPrintingPage";

import NotFound from "./pages/NotFound";
import { LanguageProvider } from "./context/LanguageContext";
import { SEOHead } from "./components/SEOHead";
import ScrollProgressBar from "./components/ScrollProgressBar";
import LangRedirect from "./components/LangRedirect";

const queryClient = new QueryClient();

const App = () => (
  <LanguageProvider>
    {/* Ladda reCAPTCHA-scriptet globalt EN gång för hela appen */}
    <script
      src="https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoadCallback&render=explicit"
      async
      defer
      id="recaptcha-script"
    ></script>
    <QueryClientProvider client={queryClient}>
      <TooltipProvider>
        <Toaster />
        <Sonner />
        <BrowserRouter>
          <ScrollProgressBar />
          <SEOHead />
          {/* Auto-redirect based on stored language preference */}
          <LangRedirect />
          <Routes>
            {/* ── Swedish routes ── */}
            <Route path="/" element={<Index />} />
            <Route path="/ai-consulting" element={<AIConsulting />} />
            <Route path="/automations" element={<AutomationsPage />} />
            <Route path="/exemple" element={<CustomersPage />} />
            <Route path="/customers" element={<Navigate to="/exemple" replace />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/klagobot" element={<KlagobotPage />} />
            <Route path="/swishkassa" element={<SwishkassaPage />} />
            <Route path="/3d-printing" element={<ThreeDPrinting />} />

            {/* ── English routes ── */}
            <Route path="/en" element={<EnPage />} />
            <Route path="/en/ai-consulting" element={<EnAIConsultingPage />} />
            <Route path="/en/automations" element={<EnAutomationsPage />} />
            <Route path="/en/exemple" element={<EnCustomersPage />} />
            <Route path="/en/customers" element={<Navigate to="/en/exemple" replace />} />
            <Route path="/en/contact" element={<EnContactPage />} />
            <Route path="/en/klagobot" element={<EnKlagobotPage />} />
            <Route path="/en/swishkassa" element={<EnSwishkassaPage />} />
            <Route path="/en/3d-printing" element={<En3DPrintingPage />} />

            {/* ── Hidden / legacy routes ── */}
            <Route path="/music-production" element={<MusicProduction />} />
            <Route path="/aimusicdreams" element={<AIMusicDreams />} />
            <Route path="/artists" element={<ArtistsPage />} />

            {/* ADD ALL CUSTOM ROUTES ABOVE THE CATCH-ALL "*" ROUTE */}
            <Route path="*" element={<NotFound />} />
          </Routes>
        </BrowserRouter>
      </TooltipProvider>
    </QueryClientProvider>
  </LanguageProvider>
);

export default App;
